module.exports = "/_next/static/images/36927eef0125bdad9abaae9be5add714-icon_parachute_heart.png";